module.exports = __webpack_public_path__ + "static/media/Personal_Care.4e2a8394.svg";